import empresa from "./empresa";
import cliente from "./cliente";

export default {
  empresa,
  cliente,
};
